const isProduction = typeof __DEV__ !== 'undefined' ? !__DEV__ : process.env.NODE_ENV === 'production';

// Suppress noisy warnings that are known and low-value.
const originalWarn = console.warn;
console.warn = (message, ...args) => {
  if (
    typeof message === 'string' &&
    (message.includes('"shadow*" style props are deprecated. Use "boxShadow".') ||
      message.includes('Animated: `useNativeDriver` is not supported because the native animated module is missing') ||
      message.includes('props.pointerEvents is deprecated. Use style.pointerEvents') ||
      message.includes('You may test your Stripe.js integration over HTTP. However, live Stripe.js integrations must use HTTPS.') ||
      message.includes('[expo-notifications] Listening to push token changes is not yet fully supported on web'))
  ) {
    return;
  }

  originalWarn.call(console, message, ...args);
};

// Reduce production noise sent to Sentry and device logs.
if (isProduction) {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}
 